<template>
    <div class="w-full h-full ">
        <div class="w-full h-full bg-white flex flex-col md:block">
            <div
                class="course-main bg-white md:max-h-full scrollbar scrollbar-md"
                id="course-main"
            >
                <documents v-if="GET_SHOW_DOCUMENTS" style="padding:0 5vw;" />

                <manual
                    v-else-if="GET_SELECTED_COURSE_TYPE == 'manual'"
                    style="padding:0 5vw;"
                />
                <target-agreement
                    v-else-if="GET_SELECTED_COURSE_TYPE == 'targetAgreement'"
                    style="padding:0 5vw;"
                />
                <slide
                    v-else-if="GET_SELECTED_COURSE_TYPE == 'slide'"
                    :style="
                        GET_SLIDE &&
                        (GET_SLIDE.type == 'video' || GET_SLIDE.type == 'pdf')
                            ? ''
                            : 'padding:0 5vw;'
                    "
                />
                <feedback
                    v-else-if="GET_SELECTED_COURSE_TYPE == 'feedback'"
                    style="padding:0 5vw;"
                />
                <certificate
                    v-else-if="GET_SELECTED_COURSE_TYPE == 'certificate'"
                    style="padding:0 5vw;"
                />
            </div>
            <course-sidebar v-if="GET_COURSE && GET_COURSE.id" />
        </div>
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onUnmounted,
    reactive,
} from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
    COURSE_TYPES,
    HELPER_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../store/types";
import Certificate from "./courseContent/Certificate.vue";
import Documents from "./courseContent/Documents.vue";
import Feedback from "./courseContent/Feedback.vue";
import Manual from "./courseContent/Manual.vue";
import Slide from "./courseContent/Slide.vue";
import TargetAgreement from "./courseContent/TargetAgreement.vue";
import CourseSidebar from "./CourseSidebar.vue";

export default defineComponent({
    components: {
        CourseSidebar,
        Manual,
        TargetAgreement,
        Slide,
        Feedback,
        Certificate,
        Documents,
    },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        const route = useRoute();
        /**
         *  Functions
         */

        async function FETCH_COURSE() {
            return store.dispatch(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.FETCH_COURSE}`,
                { courseId: route.params.id }
            );
        }
        function changeActiveFilter(id) {
            state.filters.forEach((filter) => {
                if (filter.id == id) {
                    filter.isActive = true;
                } else {
                    filter.isActive = false;
                }
            });
        }
        function SET_SELECTED_COURSE_TYPE(type) {
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                type
            );
        }
        function validateShownSlide() {
            store.commit(
                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                null
            );
            const localStorageSlideId = localStorage.getItem("goToSlideId");

            if (GET_COURSE.value.manual.is_read == false) {
                SET_SELECTED_COURSE_TYPE("manual");
            } else if (GET_COURSE.value.target_agreement_finished == false) {
                SET_SELECTED_COURSE_TYPE("targetAgreement");
            } else if (
                GET_COURSE.value.feedback_finished &&
                !localStorageSlideId
            ) {
                SET_SELECTED_COURSE_TYPE("certificate");
            } else if (
                GET_COURSE.value.total_progress.total == 100 &&
                !localStorageSlideId
            ) {
                SET_SELECTED_COURSE_TYPE("feedback");
            } else {
                // choose section and slide
                for (
                    let sectionIndex = 0;
                    sectionIndex < GET_COURSE.value.sections.length;
                    sectionIndex++
                ) {
                    const section = GET_COURSE.value.sections[sectionIndex];
                    for (
                        let slideIndex = 0;
                        slideIndex < section.slides.length;
                        slideIndex++
                    ) {
                        const slide = section.slides[slideIndex];
                        if (
                            localStorageSlideId &&
                            slide.id == localStorageSlideId
                        ) {
                            localStorage.removeItem("goToSlideId");
                            store.commit(
                                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                                slide
                            );
                            SET_SELECTED_COURSE_TYPE("slide");
                            return;
                        } else if (
                            !localStorageSlideId &&
                            slide.progress.is_finished == false
                        ) {
                            store.commit(
                                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                                slide
                            );
                            SET_SELECTED_COURSE_TYPE("slide");
                            return;
                        }
                    }
                }
            }
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_SELECTED_COURSE_TYPE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_SELECTED_COURSE_TYPE}`
                ]
        );
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );
        const GET_SHOW_DOCUMENTS = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_SHOW_DOCUMENTS}`
                ]
        );
        /**
         *  Created
         */

        store.commit(
            `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
            "isLoadingData"
        );
        Promise.all([FETCH_COURSE()]).then(() => {
            validateShownSlide();
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "isLoadingData"
            );
        });
        onUnmounted(() => {
            store.commit(`${STORE_TYPES.COURSES}/${COURSE_TYPES.RESET_STATE}`);
        });

        return {
            state,
            GET_COURSE,
            GET_SELECTED_COURSE_TYPE,
            GET_SLIDE,
            GET_SHOW_DOCUMENTS,
            changeActiveFilter,
        };
    },
});
</script>
<style lang="scss" scoped>
.course-main {
    width: 100%;
    @screen md {
        width: calc(100% - 424px);
        max-width: calc(100% - 424px);
        min-width: 60vw;
    }
}
</style>
